import { UnstyledButton, Text } from "@mantine/core";
import { Icon, IconApps } from "@tabler/icons-react";

export interface NavButtonProps {
  selected?: boolean;
  label: string;
  Icon?: Icon;
  key: number;
  id: number;
  onClick?: () => void;
}

/** Navbar button with sleek hover and selection states */
export const NavButton = ({
  selected = false,
  Icon = IconApps,
  label,
  id,
  onClick,
}: NavButtonProps) => {
  return (
    <div key={id} className="w-full">
      <UnstyledButton onClick={onClick} className="w-full">
        <div
          className={[
            "flex flex-col items-center justify-center py-3 rounded-2xl transition-all duration-300",
            selected
              ? "bg-blue-500/15 text-blue-600 shadow-sm"
              : "text-gray-600 hover:bg-gray-100/50 hover:text-gray-900",
          ].join(" ")}
        >
          <Icon
            size={26}
            className={[
              "transition-colors duration-300",
              selected ? "text-blue-600" : "",
            ].join(" ")}
          />
          <Text
            className="whitespace-pre-line text-center text-[12px] leading-snug"
            size="xs"
          >
            {label}
          </Text>
        </div>
      </UnstyledButton>
    </div>
  );
};
